module.exports = {
  query: gql`
    fragment FeactureSectionCopyFields on FeatureSectionCopyRecord {
      __typename
      heading
      intro
    }

    fragment CheckmarkItemFields on CheckmarkItemRecord {
      __typename
      text
    }

    fragment ReviewFields on ReviewRecord {
      __typename
      rating
      reviewText
    }

    fragment SquareImageFields on SquareImageRecord {
      __typename
      image {
        url: url(imgixParams: { w: 550 })
        width
        height
      }
    }

    fragment QuoteBlockFields on QuoteBlockRecord {
      __typename
      quoteText
      quotee
      quoteeRole
      portrait {
        url: url(imgixParams: { w: 75 })
      }
    }

    fragment PlanListingFields on PlanListingSectionRecord {
      plans {
        image {
          url: url(imgixParams: { w: 135, h: 135, fit: crop, auto: compress })
        }
        name
        text
        goal
        id
      }
    }

    query FeaturePage($locale: SiteLocale) {
      featuresPage(locale: $locale) {
        mainHeading
        pageIntro
        foodTrackingSection {
          ... on ImageHeadingTextBlockRecord {
            __typename
            image {
              url: url(imgixParams: { w: 230, h: 150 })
              width
              height
            }
            heading
            text
          }
          ... on FeatureSectionCopyRecord {
            __typename
            heading
            intro
          }
        }
        reviews {
          ... on ReviewRecord {
            rating
            reviewText
          }
        }
        reviewImage {
          url: url(imgixParams: { w: 650 })
          width
          height
        }
        mealPlansSection {
          ...SquareImageFields
          ...ReviewFields
          ...FeactureSectionCopyFields
          ...CheckmarkItemFields
          ...QuoteBlockFields
        }
        mealPlans {
          ...PlanListingFields
        }
        dietsSection {
          ...SquareImageFields
          ...ReviewFields
          ...FeactureSectionCopyFields
          ...CheckmarkItemFields
          ...QuoteBlockFields
        }
        diets {
          ...PlanListingFields
        }
        supplementaryCtaText
        recipesSection {
          ...SquareImageFields
          ...ReviewFields
          ...FeactureSectionCopyFields
          ...CheckmarkItemFields
          ...QuoteBlockFields
        }
        sampleRecipesHeading
        sampleRecipes {
          ... on RecipeRecord {
            recipeName
            intro
            image {
              url(imgixParams: { fit: crop, fm: jpg, auto: compress })
            }
            time
            calories
            carbs
            fiber
            sugar
            fat
            unsaturatedFat
            saturatedFat
            protein
            cholesterol
            sodium
            potassium
            instructions {
              instruction
              id
            }
            ruSwitchIngredientOrder
            ingredients {
              ingredientMetric
              ingredientUs
              ingredientName
              id
            }
          }
        }
        summarySection {
          ... on FeatureSectionCopyRecord {
            __typename
            heading
            intro
          }
          ... on IconAndTextRecord {
            __typename
            id
            icon {
              url
            }
            text
          }
        }
        pageBottomIllustration {
          url
          width
          height
        }
        pageBottomHeading
        ctaUsps {
          ... on CheckmarkItemRecord {
            text
          }
        }
      }
    }
  `,
  querySummary: gql`
    query FeaturePageQuerySummary($locale: SiteLocale) {
      featuresPage(locale: $locale) {
        summarySection {
          ... on IconAndTextRecord {
            __typename
            id
            icon {
              url
            }
            text
          }
        }
      }
    }
  `,
}
